export const STATUSES = ["Open", "In-progress", "Waiting on student", "Resolved"];
export const PRIORITIES = ["High", "Medium", "Low"];
export const QRC_TYPES = ["Query", "Request", "Complaint"];
export const LEVELS = ["None", "L1", "L2", "L3", "Out-of-SLA"];
export const ALARM_LEVELS = ["L3", "Out-of-SLA"];

export const PILL = {
  status: {
    Open: "bg-[#FEF9C3] text-black border-[#EAB308]",
    "In-progress": "bg-[#EFF6FF] text-[#1D4ED8] border-[#93C5FD]",
    "Waiting on student": "bg-[#F5F3FF] text-[#6D28D9] border-[#C4B5FD]",
    Resolved: "bg-[#DCFCE7] text-[#15803D] border-[#86EFAC]",
  },
  priority: {
    High: "bg-[#FEF2F2] text-[#B91C1C] border-[#FCA5A5]",
    Medium: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
    Low: "bg-zinc-100 text-zinc-700 border-zinc-300",
  },
  qrc: {
    Query: "bg-white text-black border-black",
    Request: "bg-[#EFF6FF] text-[#1D4ED8] border-[#93C5FD]",
    Complaint: "bg-[#FEF2F2] text-[#B91C1C] border-[#FCA5A5]",
  },
  level: {
    None: "bg-zinc-100 text-zinc-500 border-zinc-200",
    L1: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
    L2: "bg-[#FFEDD5] text-[#C2410C] border-[#FDBA74]",
    L3: "bg-[#DC2626] text-white border-[#DC2626]",
    "Out-of-SLA": "bg-black text-[#FACC15] border-black",
  },
};

export const fmtDate = (iso, opts = {}) =>
  iso
    ? new Date(iso).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        ...opts,
      })
    : "—";

export const fmtDateLong = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        weekday: "short",
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }) + " IST"
    : "—";
